import React from 'react'
import UserInvitationForm from '../components/userInvitation/userInvitationForm'
import { Redirect } from 'react-router-dom'

import useUserInvitationApi from '../hooks/userInvitations/useUserInvitationsApi'
import { useParams } from 'react-router-dom'
import UserInvitationSuccessPage from './UserInvitationPageSuccess'

export default function UserInvitationsPage() {
  const [{ userInvitationState }, { updateUserInvitation, getUserInvitation }] =
    useUserInvitationApi()
  let { id } = useParams()
  const [formSubmitted, setFormSubmitted] = React.useState(false)
  React.useEffect(() => {
    getUserInvitation(id)
  }, [])
  if (
    !userInvitationState.error &&
    !userInvitationState.isLoading &&
    formSubmitted &&
    userInvitationState?.getResponse
  ) {
    return (
      <UserInvitationSuccessPage
        code={userInvitationState?.getResponse?.code}
        accessPin={userInvitationState?.getResponse?.accessPin}
        schedules={userInvitationState?.getResponse?.schedules}
        isPermanent={userInvitationState?.getResponse?.isPermanent}
      ></UserInvitationSuccessPage>
    )

    // return <Redirect to="/userInvitationsSuccess" />
  }
  return (
    <UserInvitationForm
      onSubmit={(data) => {
        updateUserInvitation(id, data)
        setFormSubmitted(true)
      }}
      responseError={userInvitationState.error}
      invitation={userInvitationState?.getResponse}
      loading={userInvitationState.isLoading}
    />
  )
}
